<mat-select [(value)]="selectedValue" #t (selectionChange)="onSelectionChanged(t.value)" >
    <mat-option value="0">{{"All experiences" | translate}}</mat-option>
    <mat-option value="{{experience.id}}" *ngFor="let experience of experiences">{{experience.name}}</mat-option>
</mat-select>

